export default __webpack_public_path__ + "static/media/imgCardOffer3.c08e9790.jpg";